import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";
import api, { inr } from "../lib/api";
import PageHeader from "../components/PageHeader";
import StatusBadge from "../components/StatusBadge";
import OASearchSelect from "../components/OASearchSelect";

export default function OASearch() {
  const navigate = useNavigate();
  const [recent, setRecent] = useState([]);

  useEffect(() => { api.get("/oas").then(({ data }) => setRecent((data || []).slice(0, 9))).catch(() => {}); }, []);

  const open = (o) => navigate(`/oa/${o.id}/details`);

  return (
    <div>
      <PageHeader title="OA Search" subtitle="Enter an O.A. Number to open its complete linked profile — office work, invoice, items, dispatch, transporter, installer, documents" />
      <div className="p-6 lg:p-8 space-y-8">
        <div className="card p-6 max-w-2xl">
          <label className="label flex items-center gap-2"><Search className="h-4 w-4 text-amber-600" /> O.A. Number</label>
          <OASearchSelect onPick={open} placeholder="Type O.A. Number e.g. OA-2026-00125…" testid="oa-search-page" />
          <p className="text-xs text-slate-400 mt-2">Selecting an O.A. opens its master profile with every linked module and document.</p>
        </div>

        <div>
          <h3 className="font-head font-semibold text-slate-900 mb-3">Recent O.A.s</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {recent.map((o) => (
              <button key={o.id} onClick={() => open(o)} data-testid={`oa-recent-${o.oaNumber}`}
                className="card p-4 text-left hover:border-amber-400 hover:shadow-md transition-all group">
                <div className="flex items-center justify-between">
                  <span className="font-mono font-semibold text-slate-900">{o.oaNumber}</span>
                  <ArrowRight className="h-4 w-4 text-slate-300 group-hover:text-amber-500" />
                </div>
                <div className="text-sm text-slate-600 mt-1 truncate">{o.customerName}</div>
                <div className="flex items-center justify-between mt-2">
                  <StatusBadge status={o.workStatus || "pending"} />
                  <span className="text-xs text-slate-400">{inr(o.netTotal)}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
